import React, {useState} from "react";
import {DashCircle, PlusCircle} from "react-bootstrap-icons";
import {useTranslation} from 'react-i18next';

type FilterCardComponentProps = {
    children: React.ReactNode;
    isActive?: boolean;
};

const FiltersCard: React.FC<FilterCardComponentProps> = ({ children, isActive = false }) => {

    const [isFiltersActive, setIsFiltersActive] = useState(isActive ?? false);
    const {t} = useTranslation();

    return (
        <div className="card gg-filterscard mb-4">
            <div className="card-header d-flex column-gap-2 align-items-center" onClick={() => setIsFiltersActive(!isFiltersActive)}>
                <span>{t('Filters')}</span>
                {isFiltersActive ? <DashCircle /> : <PlusCircle /> }
            </div>
            <div className={`card-body collapse ${isFiltersActive ? 'show' : ''}`}>
                {children}
            </div>
        </div>
    );
};

export default FiltersCard;